import { assetBundleInitialStatic } from "../assetBundles/static/assetBundleInitialStatic";
export var assetConfig = {
    cursorUrl: assetBundleInitialStatic.cursor32_pointer,
};



//////////////////
// WEBPACK FOOTER
// ./src/setup/assetConfig.ts
// module id = 1704
// module chunks = 3